/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * API request serializer for password reset confirmation.
 * Used for OpenAPI schema generation.
 * @export
 * @interface APIAPIPasswordResetConfirmRequestRequest
 */
export interface APIAPIPasswordResetConfirmRequestRequest {
    /**
     * The password reset token
     * @type {string}
     * @memberof APIAPIPasswordResetConfirmRequestRequest
     */
    token: string;
    /**
     * The new password
     * @type {string}
     * @memberof APIAPIPasswordResetConfirmRequestRequest
     */
    password: string;
}

/**
 * Check if a given object implements the APIAPIPasswordResetConfirmRequestRequest interface.
 */
export function instanceOfAPIAPIPasswordResetConfirmRequestRequest(value: object): value is APIAPIPasswordResetConfirmRequestRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function APIAPIPasswordResetConfirmRequestRequestFromJSON(json: any): APIAPIPasswordResetConfirmRequestRequest {
    return APIAPIPasswordResetConfirmRequestRequestFromJSONTyped(json, false);
}

export function APIAPIPasswordResetConfirmRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAPIPasswordResetConfirmRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'password': json['password'],
    };
}

export function APIAPIPasswordResetConfirmRequestRequestToJSON(value?: APIAPIPasswordResetConfirmRequestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
        'password': value['password'],
    };
}

